import { gql } from '@apollo/client';
export const swapFragment = gql `
  fragment swapFields on SwapEntity {
    id
    uuid
    status
    createdAt
    updatedAt
    calculatedData {
      fullRate
      receivedAmount
    }
  }
`;
export const swapTaskFragment = gql `
  fragment swapTaskFields on SwapTaskEntity {
    name
    uuid
    status
    rateType
    rate
    email
    expiresAt
    createdAt
    refundAddress
    destinationAddress
    originalNeededAmount
    originalReceivedAmount
    accountCopy {
      address
    }
    status
    sourceAsset {
      code
      iconUrl
    }
    destinationAsset {
      code
      iconUrl
    }
  }
`;
//# sourceMappingURL=swap.js.map